import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReturnSummary } from "../../model/tax/tax_return";
import { ResourceTask, taskReducers, TaskState } from "../../utils/tasks";

export interface ReturnsState extends TaskState {
    returns: ReturnSummary[] | null;
}
  
export const initialState: ReturnsState = {
    returns: null,
    tasks: []
};
  
export const returnsSlice = createSlice({
    name: "returns",
    initialState,
    reducers: {
        ...taskReducers,
        fetchReturnsRequest: (_) => {},
        setReturns: (state, action: PayloadAction<ReturnSummary[]>) => {
            state.returns = action.payload;
        },
    },
});